import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
  name: 'format2',
})
export class Format2Pipe implements PipeTransform {
  transform(value: any) {
    value += '\n\n';
    const str = value.split('\n');
    return str
      .map((STRU: string) => {
        if (STRU.startsWith('**')) {
          return this.formataCabecalho2(STRU);
        }

        if (STRU.startsWith('##')) {
          return this.formataCabecalho3(STRU);
        }

        return this.formataParagrafo(STRU);
      })
      .join('')
      .split('<br><br>')
      .map((STR: string) => {
        let newStr = '';
        let header: string;
        if (STR.match('display')) {
          STR.split('<br>').forEach((strs: string) => {
            if (strs.startsWith('<h2')) {
              header = `<br>${strs}<hr class="bg-color-dark-grey hr-line">`;
            } else {
              if (strs.startsWith('<h3')) {
                strs = `<br>${strs}`;
              }
              newStr += strs;
            }
          });
          return `<div class="toggle-item">${header}<div class="toggle">${newStr}</div></div>`;
        }
        return STR;
      })
      .join('');
  }

  formataCabecalho2(str: string) {
    str += '\n';
    return str.replace(/\*\*\s?([A-Z].*?)\n/gi, (matchs, match) => {
      if (match.startsWith('Grupo')) {
        return `<br><br><h2 class="negrito text-uppercase display cursor-pointer color-dark">${match}</h2><br>`;
      }
      if (match.replace(/^\s+|\s+$/g, '').length > 0 && !match.startsWith('Grupo')) {
        return `<br><h2 class="negrito">${match}</h2>`;
      }
      return;
    });
  }

  formataCabecalho3(str: string) {
    str += '\n';
    return str.replace(/\#\#\s?([A-Z].*?)\n/gi, (matchs, match) => {
      if (match.replace(/^\s+|\s+$/g, '').length > 0) {
        return `<br><h3 class="negrito">${match}</h3>`;
      }
      return;
    });
  }

  formataParagrafo(str: string) {
    if (str.replace(/^\s+|\s+$/g, '').length > 0) {
      return `<p class="text-justify">${str.trim()}</p>`;
    }
  }
}
